import React from 'react';
import Container from 'react-bootstrap/Container';
import {
  BUILD_DATE,
  COPYRIGHT,
  VERSION,
} from '../../../application/common/constants';

export const Footer: React.FC = () => {
  return (
    <Container
      as="footer"
      className="py-3 px-4 d-flex justify-content-between flex-wrap"
    >
      <div>{COPYRIGHT}</div>
      <div>
        Ver {VERSION} Build Date: {BUILD_DATE}
      </div>
    </Container>
  );
};
